import React from 'react';
import './LoadingSkeleton.css';

const steps = [
  'Understanding your project...',
  'Identifying required components...',
  'Checking store availability...',
  'Calculating best prices...',
  'Preparing your component list...',
];

export default function LoadingSkeleton() {
  const [stepIdx, setStepIdx] = React.useState(0);

  React.useEffect(() => {
    const iv = setInterval(() => {
      setStepIdx(i => (i + 1) % steps.length);
    }, 1200);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="skeleton-wrap">
      <div className="skeleton-status">
        <div className="skeleton-spinner" />
        <span className="mono skeleton-step">{steps[stepIdx]}</span>
      </div>

      <div className="skeleton-project">
        <div className="skel skel-title" />
        <div className="skel skel-desc" />
        <div className="skel-stats">
          {[...Array(4)].map((_, i) => <div key={i} className="skel skel-stat" />)}
        </div>
      </div>

      {[...Array(5)].map((_, i) => (
        <div key={i} className="skeleton-card" style={{ animationDelay: `${i * 80}ms` }}>
          <div className="skel skel-checkbox" />
          <div className="skel skel-icon" />
          <div className="skel-card-info">
            <div className="skel skel-name" />
            <div className="skel skel-desc2" />
          </div>
          <div className="skel-card-right">
            <div className="skel skel-price" />
            <div className="skel skel-btn" />
          </div>
        </div>
      ))}
    </div>
  );
}
